module.exports = __webpack_public_path__ + "img/about3.a6f1cab2.png";